import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import {DepoDetail} from './DepoDetail';
import _ from 'lodash';

export class DepoHd extends TrackableEntity {
    id: number = 0;
    billTo: number = 0;
    billToName: string = '';
    paidTo: number = 0;
    paidToName: string = '';
    depositBank: number = 0;
    rglno: string = '';
    pglno: string = '';
    depositDate: string | null = null;
    postDate: string | null = null;
    checkNo: string = '';
    ccBillPayDate: string | null = null;
    remark: string = '';
    currency: string = '';
    void: number = 0;
    voidDate: string | null = null;
    type: string = '';
    block: boolean = false;
    exRate: number = 0;
    etf: number = -1; // 0 is a valid value so that change is detected
    clearActionDate: string | null = null;
    clearActionId: string = '';
    issueDate: string | null = null;
    isDraft: boolean = false;
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;
    exRateBank: number = 0;
    voidinPutDate: string | null = null;
    depositInputDate: string | null = null;
    voidInputId: string = '';
    depositInputId: string = '';
    depositBankDate: string | null = null;
    ccRefNo: string = '';
    ccStatus: number = 0;
    creditCardId: number = 0;
    ccAmt: number = 0;
    paidAmt: number = 0;
    badDebtExp: boolean = false;
    advList: DepoDetail[] = [];
    advDetailList: DepoDetail[] = [];
    acctList: DepoDetail[] = [];
    otherList: DepoDetail[] = [];
    depoDetails: DepoDetail[] = [];
    SavAcctList: DepoDetail[] = [];     // Keep acctList data
    chkPrint: boolean = false;
    chkPrtId: string = '';
    batchNo: string = '';
    chkPrtDate: string | null = null;
    isAgentPayment: number = 0;
    confirmedCrDbId: number = 0;
    bankName: string = '';
    creditCardName: string = '';
    ccEntity: string = '';
    ccPrefix: string = '';
    ccRefNo2: string = '';
    isVoid: boolean = false;
    advRcvPaid: number = 0;
    advPayPaid: number = 0;
    advRcvDecAmt: number = 0;
    advRcvIncAmt: number = 0;
    advRcvLAmount: number = 0;
    advRcvOAmount: number = 0;
    advPayDecAmt: number = 0;
    advPayIncAmt: number = 0;
    advPayLAmount: number = 0;
    advPayOAmount: number = 0;
    tAmount: number = 0;
    tlAmount: number = 0;
    tbAmount: number = 0;
    tglAmount: number = 0;
    tInvAmount: number = 0;
    tDueAmount: number = 0;
    tRcvdAmount: number = 0;
    tnoPsAmount: number = 0;
    curDesc: string = '';
    isAll: boolean = false;
    isAR: boolean = false;
    isAP: boolean = false;
    isReceivable: boolean = false;
    isPayable: boolean = false;
    isARAgent: boolean = false;
    isAPAgent: boolean = false;
    isCrDb: boolean = false;
    isCrDbConfrimed: boolean = false;
    isInvConfrimed: boolean = false;
    isBillConfrimed: boolean = false;
    searchFrom: string | null = null;
    searchTo: string | null = null;
    searchDueDateFrom: string | null = null;
    searchDueDateTo: string | null = null;
    closeDate: string | null = null;
    info: DepoHdInfo[] = []; // Added temporarily to avoid ts errors. Needs to be removed in the future
    depositBankBranch:string = '';

    hdIsClosed: boolean = false;
    editable: boolean = true;
    defaultVoidDate: string | null = null;
    defaultNSFDate: string | null = null;
    draftPaid: boolean = false;

    paymentGlInfo: PaymentGLInfo[] = [];
    // Cloud Only
    closeBy: string = '';
    isBlockVisible: boolean = false;
    bConfirmMsg: boolean = true;
    bankChargeDesc: string = '';
    isNonOPBalance: boolean = false;
    dBankChargeExRate: number = 0;
    dBankChargeAmount: number = 0;
    bMultiEntity: boolean = false;
    oldBillToName: string = '';
    oldBillTo: number = 0;
    oldPostDate: string | null = null;
    isSaveButton: boolean = false;
    refreshAcctTargets: { parent: string, id: number, sParent: string  }[] = [];
    needsRefresh: boolean = false;
    bankBranch: string = '';

    acctGridPosition: number = 0;   // Scroll 위치를 저장

    searchedFrom: string | null = null;     // Grid의 검색이 적용된 FromDate
    searchedTo: string | null = null;       // Grid의 검색이 적용된 ToDate

    //#region Begin Date ~ Today까지의 잔액

    // Common
    initTAmount: number = 0;
    initTLAmount: number = 0;
    initTBAmount: number = 0;
    initTGLAmount: number = 0;
    initAdvRcvdBalance: number = 0;
    initAdvPymtBalance: number = 0;

    //#endregion

    //#region Begin Date ~ Accrual Date까지의 잔액 (Foreign Currency인 경우 사용됨)

    useBank: boolean = false;
    bankExRate: number = 0;
    bankBalance: number = 0;
    bankBalanceF: number = 0;

    advRcvdExRate: number = 0;
    advRcvdBalance: number = 0;
    advRcvdBalanceF: number = 0;

    advPymtExRate: number = 0;
    advPymtBalance: number = 0;
    advPymtBalanceF: number = 0;

    periodActionDate: string | null = null;
    // for check depositDate
    loadDepositDate: boolean = false; //boolean 형태로 변경

    //for head filter
    oriAcctList: DepoDetail[] = [];
    //#endregion

    fileClose: string ='';

    constructor(init?:Partial<DepoHd>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'depoDetails', 'chkPrint', 'chkPrtId', 'batchNo', 'chkPrtDate', 'isAgentPayment', 'confirmedCrDbId', 'bankName', 'creditCardName', 
        'ccEntity', 'ccPrefix', 'ccRefNo2', 'isVoid', 'advRcvPaid', 'advPayPaid', 'advRcvDecAmt', 'advRcvIncAmt', 'advRcvLAmount', 'advRcvOAmount', 
        'advPayDecAmt', 'advPayIncAmt', 'advPayLAmount', 'advPayOAmount',
        //'tAmount', 'tlAmount', 'tbAmount', 'tglAmount',       // 230817.dwshin - Original Value와 차이 비교해야해서 필요함.
        'tInvAmount', 'tDueAmount', 
        //'tRcvdAmount',
        'tnoPsAmount', 'curDesc', 'isAll', 'isAR', 'isAP', 'isReceivable', 'isPayable', 'isARAgent', 'isAPAgent', 'isCrDbConfrimed','isInvConfrimed', 'isBillConfrimed',
        'isSearchPeriod', 'searchFrom', 'searchTo', 'searchDueDateFrom', 'searchDueDateTo', 'closeDate', 'closeBy', 
        'isBlockVisible', 'bConfirmMsg', 'bankChargeDesc', 'dBankChargeExRate', 'dBankChargeAmount', 'isNonOPBalance', 
        'initTAmount', 'initTLAmount', 'initTBAmount', 'initTGLAmount', 'initAdvRcvdBalance', 'initAdvPymtBalance', 
        'useBank', 'bankExRate', 'bankBalance', 'bankBalanceF', 'paymentGlInfo',
        'advRcvdExRate', 'advRcvdBalance', 'advRcvdBalanceF',
        'advPymtExRate', 'advPymtBalance', 'advPymtBalanceF', 
        'hdIsClosed', 'editable', 'bMultiEntity', 'oldBillToName', 'oldBillTo, isSaveButton', 'refreshAcctTargets', 'needsRefresh', 'loadDepositDate', 'oriAcctList'
        );
        this.getdateProps.push('u1Date', 'u2Date'); 
        //GetNextId가 여러번 호출되어 각 View에서 호출되도록 처리
        //if(this.id === 0) this.id = this.GetNextId();

        // AdvList : 화면상에 표시되는 리스트
        if(this.advList.length > 0){
            this.advList = this.advList.map(d => new DepoDetail(d));
        } else {
            this.advList = [];
        }
        // advDetailList : 데이터를 읽어오고 저장하는 리스트 
        if(this.advDetailList.length > 0){
            this.advDetailList = this.advDetailList.map(d => new DepoDetail(d));
        } else {
            this.advDetailList = [];
        }
        if(this.acctList.length > 0){
            this.acctList = this.acctList.map(d => new DepoDetail(d));
        } else {
            this.acctList = [];
        }
        if(this.otherList.length > 0){
            this.otherList = this.otherList.map(d => new DepoDetail(d));
        } else {
            this.otherList = [];
        }
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(DepoHd.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = DepoHd.dicFieldMappings[m];
        });

        _.keys(DepoDetail.dicFieldMappings).forEach(m=>{
            dicFieldMap[`advDetailList.${m}`] = DepoDetail.dicFieldMappings[m];
        });

        _.keys(DepoDetail.dicFieldMappings).forEach(m=>{
            dicFieldMap[`acctList.${m}`] = DepoDetail.dicFieldMappings[m];
        });

        _.keys(DepoDetail.dicFieldMappings).forEach(m=>{
            dicFieldMap[`otherList.${m}`] = DepoDetail.dicFieldMappings[m];
        });
        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_DEPOHD' }),
        'billTo': new DBMappingInfo({ field: 'F_BillTo', table: 'T_DEPOHD' }),
        'postDate': new DBMappingInfo({ field: 'F_PostDate', table: 'T_DEPOHD' }),
        'voidDate': new DBMappingInfo({ field: 'F_VoidDate', table: 'T_DEPOHD' }),
        'depositDate': new DBMappingInfo({ field: 'F_DepositDate', table: 'T_DEPOHD' }),
        'paidTo': new DBMappingInfo({ field: 'F_PaidTo', table: 'T_DEPOHD' }),
        'paidToName': new DBMappingInfo({ field: 'F_ReceivedFrom', table: 'T_DEPOHD' }),
        'currency': new DBMappingInfo({ field: 'F_Currency', table: 'T_DEPOHD' }),
        'checkNo': new DBMappingInfo({ field: 'F_CheckNo', table: 'T_DEPOHD' }),
        'ccBillPayDate': new DBMappingInfo({ field: 'F_CCBillPayDate', table: 'T_DEPOHD'}),
        'remark': new DBMappingInfo({ field: 'F_Remark', table: 'T_DEPOHD' }),
        'depositBank': new DBMappingInfo({ field: 'F_DepositBank', table: 'T_DEPOHD' }),
        'void': new DBMappingInfo({ field: 'F_Void', table: 'T_DEPOHD' }),
        'type': new DBMappingInfo({ field: 'F_Type', table: 'T_DEPOHD' }),
        'block': new DBMappingInfo({ field: 'F_Block', table: 'T_DEPOHD' }),
        'exRate': new DBMappingInfo({ field: 'F_EXRATE', table: 'T_DEPOHD' }),
        'etf': new DBMappingInfo({ field: 'F_ETF', table: 'T_DEPOHD' }),
        'issueDate': new DBMappingInfo({ field: 'F_IssueDate', table: 'T_DEPOHD' }),
        'clearActionDate': new DBMappingInfo({ field: 'F_ClearActionDate', table: 'T_DEPOHD' }),
        'exRateBank': new DBMappingInfo({ field: 'F_ExRateBank', table: 'T_DEPOHD' }),
        'isDraft': new DBMappingInfo({ field: 'F_IsDraft', table: 'T_DEPOHD' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1ID', table: 'T_DEPOHD' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1DATE', table: 'T_DEPOHD' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2ID', table: 'T_DEPOHD' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2DATE', table: 'T_DEPOHD' }),
        'ccRefNo': new DBMappingInfo({ field: 'F_CCRefNo', table: 'T_DEPOHD' }),
        'creditCardId': new DBMappingInfo({ field: 'F_CreditCardId', table: 'T_DEPOHD' }),
        'ccAmt': new DBMappingInfo({ field: 'F_CCAmt', table: 'T_DEPOHD' }),
        'isAgentPayment': new DBMappingInfo({ field: 'F_IsAgentPayment', table: 'T_DEPOHD' }),
    };

    setChildTrackable(value: boolean): void {
        if(this.advList.length > 0) {
            this.advList.forEach(c => c.trackable = value);
        }
        if(this.acctList.length > 0) {
            this.acctList.forEach(c => c.trackable = value);
        }
        if(this.advDetailList.length > 0) {
            this.advDetailList.forEach(c => c.trackable = value);
        }
        if(this.otherList.length > 0) {
            this.otherList.forEach(c => c.trackable = value);
        }
    }
}

export class PaymentGLInfo {
    glType: string = '';
    glNo: string = '';
    glDesc: string = '';
    currency: string = '';
    exRate: number = 0;
    balance: number = 0;
    balanceF: number = 0;
    sortNo: string = '';
    isDefault: number = 0;    
    // showOption: string = ''; // 1 = 'Always' / 2 = Balance > 0 / 3 = Balance != 0

    constructor(init?:Partial<PaymentGLInfo>) {
        Object.assign(this, init);
    }
}

export class DepoHdInfo {
    id: number = 0;
    checkNo: string = '';
    billToName: string = '';
    paidToName: string = '';
    isDraft: boolean = false;
    bankName: string = '';
    creditCardName: string = '';
    totalAmount: number = 0;
    exRate: number = 0;
    currency: string = '';
    paymentType: string = '';
    ccRefNo: string = '';
    accrualDate: string | null = null;
    postDate: string | null = null;
    ccBillPayDate: string | null = null;

    constructor(init?:Partial<DepoHdInfo>) {
        Object.assign(this, init);
    }
}
